export default function HeroSection() {
  const tiers = [
    { bg: "#a3e635", count: 3 },
    { bg: "#71717a", count: 3 },
    { bg: "#3f3f46", count: 4 },
  ];

  return (
    <section className="max-w-[1200px] mx-auto px-6 md:pt-[12rem] pt-[10rem] pb-10 sm:pb-22 relative">
      <div
        className="font-mono text-[12px] tracking-[0.18em] text-[#a3e635] mb-7"
        style={{ letterSpacing: "0.18em" }}
      >
        NO IT BACKGROUND · NO CODING TO START · 10 LEVELS · 100% ONLINE
      </div>
      <h1
        className="font-bold text-white mb-6 max-w-[900px]"
        style={{
          fontSize: "clamp(40px, 6.2vw, 76px)",
          lineHeight: 0.98,
          letterSpacing: "-0.035em",
        }}
      >
        Nobody is born knowing how to defend a network.
        <br />
        <span className="text-[#52525b]">
          You get taught. Level by level.
        </span>
      </h1>
      <div className="flex flex-wrap gap-[9px] mb-7">
        <span className="border border-[#a3e635] text-[#a3e635] rounded-full px-3.5 py-[7px] font-mono text-[11px] tracking-[0.08em]">
          AI SECURITY IN ALL 10 LEVELS
        </span>
        <span className="border border-[#3f3f46] text-[#d4d4d8] rounded-full px-3.5 py-[7px] font-mono text-[11px] tracking-[0.08em]">
          SYLLABUS REFRESHED FOR 2026
        </span>
        <span className="border border-[#3f3f46] text-[#d4d4d8] rounded-full px-3.5 py-[7px] font-mono text-[11px] tracking-[0.08em]">
          CERTIFICATE AFTER EVERY LEVEL
        </span>
        <span className="border border-[#3f3f46] text-[#d4d4d8] rounded-full px-3.5 py-[7px] font-mono text-[11px] tracking-[0.08em]">
          $499 FOR THE WHOLE TRACK
        </span>
      </div>
      <p className="text-[16px] sm:text-[19px] leading-[1.6] text-[#a1a1aa] max-w-[640px] mb-10">
        You do not need a degree, a coding background or anyone&apos;s
        permission. Ten levels, one year, entirely online &mdash; recorded
        video plus hands-on labs you can start tonight. We begin at what a
        network actually is and finish with you red-teaming an AI agent and
        hardening a multi-cloud estate. Pass the online exam at the end of
        every level and collect a certificate each time.
      </p>
      <div className="flex gap-3.5 flex-wrap mb-8 sm:mb-16">
        <a
          href="#enroll"
          className="bg-white text-black px-5 sm:px-[30px] py-[15px] rounded-lg font-semibold text-[16px] hover:bg-[#e4e4e7] transition-colors"
        >
          Enroll in the Expert Track
        </a>
        <a
          href="#roadmap"
          className="border border-[#3f3f46] text-white px-5 sm:px-[30px] py-[15px] rounded-lg font-semibold text-[16px] hover:border-white transition-colors"
        >
          See all 10 levels
        </a>
      </div>
      <div className="grid grid-cols-5 sm:grid-cols-10 gap-1.5 mb-[22px]">
        {tiers.map((tier, ti) =>
          Array.from({ length: tier.count }).map((_, i) => (
            <div
              key={`${ti}-${i}`}
              className="h-[5px] rounded-sm"
              style={{ background: tier.bg }}
            />
          ))
        )}
      </div>
      <div className="flex gap-4 sm:gap-9 flex-wrap font-mono text-[12px] text-[#71717a] tracking-[0.08em]">
        <span>L1–L3 &nbsp;FOUNDATION</span>
        <span>L4–L6 &nbsp;CORE PRACTITIONER</span>
        <span>L7–L10 &nbsp;EXPERT</span>
      </div>
    </section>
  );
}
